"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileHeartSolid: function() {
        return FileHeartSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileHeartSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM14 3.5L18.5 8H15C14.4477 8 14 7.55228 14 7V3.5ZM11.9976 13.2119C11.2978 12.4328 10.1309 12.2232 9.25414 12.9367C8.37738 13.6501 8.25394 14.843 8.94247 15.6868C9.15464 15.9468 9.69055 16.3051 10.2745 16.6955C10.9106 17.1206 11.6036 17.5839 11.9976 18C12.3912 17.5836 13.0852 17.1198 13.7219 16.6943C14.3054 16.3043 14.8408 15.9465 15.0527 15.6868C15.7413 14.843 15.6329 13.6426 14.7411 12.9367C13.8492 12.2307 12.6974 12.4328 11.9976 13.2119Z",
        fill: "currentColor"
    })
}), "FileHeartSolid");
const _default = FileHeartSolid;
